import react from "react";
// import {
//     Content
// } from "antd";
import {
    Row,
    Col,
    Form,
    Input,
    Divider,
    Select,
    theme,
} from "antd";
import { Content } from "antd/es/layout/layout";
import Heading from "../../../../components/common/heading";
import {MultipleAutoComplete,Autocomplete} from "../../../../components/common/autoCompleteV2";
const { useToken } = theme;
const CustomerCompetitorAdd = (value) =>{
    const { token } = useToken();
    const [form] = Form.useForm();
    const {
        header,
        regionGroup,
        productRequirement,
        otherProductExpect,
        customerSupport,
        otherSupportExpect,
        businessRequire,
        otherBusinessExpect,
        customerExpect
    } = value;
    const { Option } = Select;
    return (
        <Content>
            <Row gutter={[16, 8]} className="card">
                <Col span={24}>
                <Heading
                    text={header}
                    size={4}
                    style={{ margin: 0, color: token.thPrimary }}
                />
                <Divider />
                </Col>
                <Col span={16}>
                    <Form.Item
                    label="ชื่อสถานประกอบการ/ชื่อโรงงาน (TH)"
                    name={"factoryNameTh"}
                    rules={[
                        {
                        required: true,
                        message: "โปรดระบุ",
                        },
                    ]}
                    >
                    <Input placeholder="ชื่อสถานประกอบการ/ชื่อโรงงาน (TH)" />
                    </Form.Item>
                </Col>

                <Col span={16}>
                    <Form.Item
                    label="ชื่อสถานประกอบการ/ชื่อโรงงาน (EN)"
                    name={"factoryNameEn"}
                    rules={[
                        {
                        required: true,
                        message: "โปรดระบุ",
                        },
                    ]}
                    >
                    <Input placeholder="ชื่อสถานประกอบการ/ชื่อโรงงาน (EN)" />
                    </Form.Item>
                </Col>
                <Col span={16}>
                    <Form.Item
                    label="กลุ่มลูกค้าตามสัญชาติ (ตอบได้มากกว่า 1 ข้อ)"
                    name={"customerGroupByRegion"}
                    rules={[
                        {
                        required: true,
                        message: "โปรดระบุ",
                        },
                    ]}
                    >
                    <Select
                        allowClear
                        mode="multiple"
                        maxTagCount={"responsive"}
                        style={{
                        width: "100%",
                        }}
                        placeholder="กรุณาเลือก"
                    >
                        {regionGroup.map((item) => (
                        <Option value={item.dataId}>{item.dataDetailTh}</Option>
                        ))}
                    </Select>
                    </Form.Item>
                </Col>
                <Col span={16}>
                    <Form.Item
                    label="สัญชาติลูกค้า (ประเทศ)"
                    name={"customerRegion"}
                    rules={[
                        {
                        required: true,
                        message: "โปรดระบุ",
                        },
                    ]}
                    >
                    {/* <Select
                        allowClear
                        style={{
                        width: "100%",
                        }}
                        placeholder="กรุณาเลือก"
                    >
                        {countries.map((item) => (
                        <Option key={item.countryId} value={item.countryId}>
                            {item.countryNameTh}
                        </Option>
                        ))}
                    </Select> */}
                    <MultipleAutoComplete
                        multiple={false}
                        subject="countryOrderNameTh"
                        valueField="countryId"
                        labelField="countryNameTh"
                        placeholder="กรุณาเลือก"
                    />
                    </Form.Item>
                </Col>
                <Col span={24}>
                    <Divider dashed />
                </Col>
                <Heading
                    text={"ข้อคำถาม"}
                    size={4}
                    style={{ margin: 0, color: token.thPrimary }}
                />    
                <Col span={24}>
                    <Divider dashed />
                </Col>
                <Col span={24}>
                    <div style={{ fontWeight: 600, fontSize: 16 }}>
                        ด้านผลิตภัณฑ์และบริการ
                    </div>
                </Col>
                <Col span={24}>
                    <Form.Item
                        label="1.ลูกค้ามีความต้องการ ด้านผลิตภัณฑ์และบริการ ของ กนอ. อย่างไร (ตอบได้มากกว่า 1 ข้อ)"
                        name={["productAndServiceWant"]}
                        rules={[
                        {
                            required: true,
                            message: "โปรดระบุ",
                        },
                        ]}
                    >
                        <Select
                        allowClear
                        mode="multiple"
                        maxTagCount={"responsive"}
                        style={{
                            width: "100%",
                        }}
                        placeholder="กรุณาเลือก"
                        >
                        {productRequirement &&
                            productRequirement.map((item) => (
                            <Option
                                key={item.vocUniqueId}
                                value={item.vocUniqueId}
                            >
                                {item.vocDetailTh}
                            </Option>
                            ))}
                        </Select>
                    </Form.Item>
                    {form.getFieldValue(["productAndServiceWant"]) &&
                        form
                        .getFieldValue(["productAndServiceWant"])
                        .includes("-99") === true && (
                        <Form.Item
                            label=""
                            name={[
                            "productAndServiceWantSpecify",
                            ,
                            ]}
                            style={{ marginTop: 8 }}
                        >
                            <Input.TextArea placeholder="รายละเอียด (อื่นๆ)" />
                        </Form.Item>
                        )}
                    </Col>
                    <Col span={24}>
                    <Form.Item
                        label="2.ลูกค้ามีความคาดหวังที่นอกเหนือจากความต้องการ ด้านผลิตภัณฑ์และบริการ ของ กนอ. อย่างไร (ตอบได้มากกว่า 1 ข้อ)"
                        name={["productAndServiceExpected", ]}
                    >
                        <Select
                        allowClear
                        mode="multiple"
                        maxTagCount={"responsive"}
                        style={{
                            width: "100%",
                        }}
                        placeholder="กรุณาเลือก"
                        >
                        {otherProductExpect &&
                            otherProductExpect.map((item) => (
                            <Option
                                key={item.vocUniqueId}
                                value={item.vocUniqueId}
                            >
                                {item.vocDetailTh}
                            </Option>
                            ))}
                        </Select>
                    </Form.Item>
                    {form.getFieldValue([
                        "productAndServiceExpected"
                    ]) &&
                        form
                        .getFieldValue(["productAndServiceExpected"])
                        .includes("-99") === true && (
                        <Form.Item
                            label=""
                            name={[
                            "productAndServiceExpectedSpecify",
                            ,
                            ]}
                            style={{ marginTop: 8 }}
                        >
                            <Input.TextArea placeholder="รายละเอียด (อื่นๆ)" />
                        </Form.Item>
                        )}
                    </Col>

                    <Col span={24}>
                    <div
                        style={{
                        fontWeight: 600,
                        fontSize: 16,
                        marginTop: 20,
                        }}
                    >
                        ด้านสนับสนุนลูกค้า
                    </div>
                    </Col>
                    <Col span={24}>
                    <Form.Item
                        label="1.ลูกค้ามีความต้องการ ด้านสนับสนุนลูกค้า ของ กนอ. อย่างไร (ตอบได้มากกว่า 1 ข้อ)"
                        name={["supportWant", ]}
                        rules={[
                        {
                            required: true,
                            message: "โปรดระบุ",
                        },
                        ]}
                    >
                        <Select
                        allowClear
                        mode={"multiple"}
                        maxTagCount={"responsive"}
                        style={{
                            width: "100%",
                        }}
                        placeholder="กรุณาเลือก"
                        >
                        {customerSupport &&
                            customerSupport.map((item) => (
                            <Option
                                key={item.vocUniqueId}
                                value={item.vocUniqueId}
                            >
                                {item.vocDetailTh}
                            </Option>
                            ))}
                        </Select>
                    </Form.Item>
                    {form.getFieldValue(["supportWant"]) &&
                        form
                        .getFieldValue(["supportWant"])
                        .includes("-99") === true && (
                        <Form.Item
                            label=""
                            name={["supportWantSpecify", ]}
                            style={{ marginTop: 8 }}
                        >
                            <Input.TextArea placeholder="รายละเอียด (อื่นๆ)" />
                        </Form.Item>
                        )}
                    </Col>
                    <Col span={24}>
                    <Form.Item
                        label="2.ลูกค้ามีความคาดหวังที่นอกเหนือจากความต้องการ ด้านสนับสนุนลูกค้า ของ กนอ. อย่างไร (ตอบได้มากกว่า 1 ข้อ)"
                        name={["supportExpected", ]}
                    >
                        <Select
                        allowClear
                        mode={"multiple"}
                        maxTagCount={"responsive"}
                        style={{
                            width: "100%",
                        }}
                        placeholder="กรุณาเลือก"
                        >
                        {otherSupportExpect &&
                            otherSupportExpect.map((item) => (
                            <Option
                                key={item.vocUniqueId}
                                value={item.vocUniqueId}
                            >
                                {item.vocDetailTh}
                            </Option>
                            ))}
                        </Select>
                    </Form.Item>
                    {form.getFieldValue(["supportExpected"]) &&
                        form
                        .getFieldValue(["supportExpected"])
                        .includes("-99") === true && (
                        <Form.Item
                            label=""
                            name={["supportExpectedSpecify", ]}
                            style={{ marginTop: 8 }}
                        >
                            <Input.TextArea placeholder="รายละเอียด (อื่นๆ)" />
                        </Form.Item>
                        )}
                    </Col>

                    <Col span={24}>
                    <div
                        style={{
                        fontWeight: 600,
                        fontSize: 16,
                        marginTop: 20,
                        }}
                    >
                        ด้านการทำธุรกรรม
                    </div>
                    </Col>
                    <Col span={24}>
                    <Form.Item
                        label="1.ลูกค้ามีความต้องการ ด้านการทำธุรกรรม (อนุมัติอนุญาตสิทธิประโยชน์) ของ กนอ. อย่างไร (ตอบได้มากกว่า 1 ข้อ)"
                        name={["transactionWant", ]}
                        rules={[
                        {
                            required: true,
                            message: "โปรดระบุ",
                        },
                        ]}
                    >
                        <Select
                        allowClear
                        mode={"multiple"}
                        maxTagCount={"responsive"}
                        style={{
                            width: "100%",
                        }}
                        placeholder="กรุณาเลือก"
                        >
                        {businessRequire &&
                            businessRequire.map((item) => (
                            <Option
                                key={item.vocUniqueId}
                                value={item.vocUniqueId}
                            >
                                {item.vocDetailTh}
                            </Option>
                            ))}
                        </Select>
                    </Form.Item>
                    {form.getFieldValue(["transactionWant"]) &&
                        form
                        .getFieldValue(["transactionWant"])
                        .includes("-99") === true && (
                        <Form.Item
                            label=""
                            name={["transactionWantSpecify", ]}
                            style={{ marginTop: 8 }}
                        >
                            <Input.TextArea placeholder="รายละเอียด (อื่นๆ)" />
                        </Form.Item>
                        )}
                    </Col>
                    <Col span={24}>
                    <Form.Item
                        label="2.ลูกค้ามีความคาดหวังที่นอกเหนือจากความต้องการ ด้านการทำธุรกรรม (อนุมัติอนุญาตสิทธิประโยชน์) ของ กนอ. อย่างไร (ตอบได้มากกว่า 1 ข้อ)"
                        name={["transactionExpected", ]}
                    >
                        <Select
                        allowClear
                        style={{
                            width: "100%",
                        }}
                        placeholder="กรุณาเลือก"
                        maxTagCount={"responsive"}
                        mode={"multiple"}
                        >
                        {otherBusinessExpect &&
                            otherBusinessExpect.map((item) => (
                            <Option
                                key={item.vocUniqueId}
                                value={item.vocUniqueId}
                            >
                                {item.vocDetailTh}
                            </Option>
                            ))}
                        </Select>
                    </Form.Item>
                    {form.getFieldValue(["transactionExpected"]) &&
                        form
                        .getFieldValue(["transactionExpected"])
                        .includes("-99") === true && (
                        <Form.Item
                            label=""
                            name={["transactionExpectedSpecify", ]}
                            style={{ marginTop: 8 }}
                        >
                            <Input.TextArea placeholder="รายละเอียด (อื่นๆ)" />
                        </Form.Item>
                        )}
                    </Col>

                    <Col span={24}>
                    <div
                        style={{
                        fontWeight: 600,
                        fontSize: 16,
                        marginTop: 20,
                        }}
                    >
                        ด้านการจัดการความสัมพันธ์ (CRM)
                    </div>
                    </Col>
                    <Col span={24}>
                    <Form.Item
                        label="1.ลูกค้ามีความต้องการ/คาดหวัง ด้านการจัดการความสัมพันธ์(CRM) ของ กนอ. อย่างไร (ตอบได้มากกว่า 1 ข้อ)"
                        name={["crmExpected", ]}
                        rules={[
                        {
                            required: true,
                            message: "โปรดระบุ",
                        },
                        ]}
                    >
                        <Select
                        allowClear
                        style={{
                            width: "100%",
                        }}
                        placeholder="กรุณาเลือก"
                        mode={"multiple"}
                        maxTagCount={"responsive"}
                        >
                        {customerExpect &&
                            customerExpect.map((item) => (
                            <Option
                                key={item.vocUniqueId}
                                value={item.vocUniqueId}
                            >
                                {item.vocDetailTh}
                            </Option>
                            ))}
                        </Select>
                    </Form.Item>
                    {form.getFieldValue(["crmExpected"]) &&
                        form
                        .getFieldValue(["crmExpected"])
                        .includes("-99") === true && (
                        <Form.Item
                            label=""
                            name={["crmExpectedSpecify", ]}
                            style={{ marginTop: 8 }}
                        >
                            <Input.TextArea placeholder="รายละเอียด (อื่นๆ)" />
                        </Form.Item>
                        )}
                    </Col>
                    <Col span={24}>
                    <Form.Item
                        label="2.ข้อเสนอแนะด้านผลิตภัณฑ์และบริการ (ถ้ามี)"
                        name={["productAndServiceSuggestion", ]}
                    >
                        <Input.TextArea placeholder="รายละเอียด" />
                    </Form.Item>
                    </Col>
                    <Col span={24}>
                    <Form.Item
                        label="3.ข้อเสนอแนะด้านสนับสนุนลูกค้า (ถ้ามี)"
                        name={["supportSuggestion", ]}
                    >
                        <Input.TextArea placeholder="รายละเอียด" />
                    </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            label="4.ข้อเสนอแนะด้านการทำธุรกรรม (อนุมัติ, อนุญาตและสิทธิประโยชน์) (ถ้ามี)"
                            name={["transactionSuggestion", ]}
                        >
                            <Input.TextArea placeholder="รายละเอียด" />
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                    <Form.Item
                        label="5.ข้อเสนอแนะด้านการจัดการความสัมพันธ์กับลูกค้า (CRM) (ถ้ามี)"
                        name={["crmSuggestion", ]}
                    >
                        <Input.TextArea placeholder="รายละเอียด" />
                    </Form.Item>
                    </Col>
                    <Col span={24}>
                    <Form.Item
                        label="6.สิ่งที่ไม่พึ่งพอใจต้องการให้ปรับปรุงอย่างเร่งด่วน (ถ้ามี)"
                        name={["notSatisfied", ]}
                    >
                        <Input.TextArea placeholder="รายละเอียด" />
                    </Form.Item>
                </Col>
            </Row>
        </Content>
    )

}

export default CustomerCompetitorAdd;